import React from 'react'
import { FEATURE_UC_IN_WEBREGISTER_LOCK_ICON } from '../../../../constants'
import { getFeatureFromCache } from '../../../../util/feature-cache'
import { NoteLabelProps } from './useNoteLabelModel'
import { NoteLabel as NoteLabelUnified } from './NoteLabel'
import { NoteLabelLegacy } from './NoteLabelLegacy'

export const NoteLabel: React.FC<NoteLabelProps> = props => {
  const isUnifiedEnabled = getFeatureFromCache(
    FEATURE_UC_IN_WEBREGISTER_LOCK_ICON
  )

  return isUnifiedEnabled ? (
    <NoteLabelUnified {...props} />
  ) : (
    <NoteLabelLegacy {...props} />
  )
}
